module.exports = __webpack_public_path__ + "h5/img/mfe_10.79d9a67c.jpeg";